import { createRouter, createWebHistory } from 'vue-router'
import { getToken, setTitle } from '@/libs/util'
import config from '@/config'
import ViewUIPlus from 'view-ui-plus'

const router = createRouter({
  // 使用 history 模式
  history: createWebHistory(process.env.BASE_URL), // 如果需要基础路径，可以传入参数，例如 createWebHistory('/base/')
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login.vue'), // 动态导入组件
      meta: { requiresAuth: false },
    },
    {
      path: '/RentalManagement',
      name: 'RentalManagement',
      component: () => import('@/views/RentalManagement.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('@/views/HomeView.vue'), 
      meta: { requiresAuth: true },
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/login'
    }
  ],
});


// 全局路由守卫
const HOME_NAME  = config.HomeName
const LOGIN_PAGE_NAME = 'Login'
let beforeEachCount = 0

// const turnTo = (to, access, next) => {
//   if (canTurnTo(to.name, access, routes)) next() // 有权限，可访问
//   else next({ replace: true, name: 'error_401' }) // 无权限，重定向到401页面
// }

// router.beforeEach((to, from, next) => { 
//   beforeEachCount++;
//   console.log(`beforeEach executed ${beforeEachCount} times`);
//   ViewUIPlus.LoadingBar.start()
//   const token = getToken()
//   if (!token && to.name !== LOGIN_PAGE_NAME) {
//     // 未登录且要跳转的页面不是登录页
//     next({
//       name: LOGIN_PAGE_NAME // 跳转到登录页
//     })
//   } else if (!token && to.name === LOGIN_PAGE_NAME) {
//     // 未登陆且要跳转的页面是登录页
//     next() // 跳转
//   } else if (token && to.name === LOGIN_PAGE_NAME) {
//     // 已登录且要跳转的页面是登录页
//     next({name: HOME_NAME})
//   // } else {
//   //   if (store.state.user.hasGetInfo) {
//   //     turnTo(to, store.state.user.access, next)
//   //   } else {
//   //     store.dispatch('GetUserInfo').then(user => { 
//   //       // 拉取用户信息，通过用户权限和跳转的页面的name来判断是否有权限访问;access必须是一个数组，如：['super_admin'] ['super_admin', 'admin']
//   //       turnTo(to, user.Data.Access, next)
//   //     }).catch(() => {
//   //       setToken('')
//   //       next({
//   //         name: 'login'
//   //       })
//   //     })
//   //   }
//   }
// })

router.beforeEach((to, from, next) => {
  beforeEachCount++;
  console.log(`beforeEach executed ${beforeEachCount} times`)
  const cachedToken= getToken()
  // console.log('Token cached:', cachedToken)
  // console.log('Navigating from:', from.name)
  // console.log('Navigating to:', to.name)
  // console.log('Requires Auth:', to.meta.requiresAuth)
  // console.log('User authenticated:', !!cachedToken)
  const isAuthenticated = !!cachedToken // 判断是否有 token
  // 第一个叹号 (!) 会将值转换为布尔值并取反：
  // 如果 cachedToken 是 truthy 值（如非空字符串、非零数字、对象等），!cachedToken 返回 false
  // 如果 cachedToken 是 falsy 值（如 null、undefined、0、"" 等），!cachedToken 返回 true
  // 第二个叹号 (!) 会再次取反，得到原始的布尔表示：
  // 如果 cachedToken 是 truthy 值，!!cachedToken 返回 true
  // 如果 cachedToken 是 falsy 值，!!cachedToken 返回 false
  // 等价于 const isAuthenticated = Boolean(cachedToken)
  if (to.meta.requiresAuth) {
    if(isAuthenticated){
      next()
    }else{
      //console.log('路由需要认证且用户未登录，重定向到登录页面.')
      next({ name: LOGIN_PAGE_NAME })
    }
  } else {
    next()
  }
})

router.afterEach(to => {
  setTitle(to, router.app)
  ViewUIPlus.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router